export const SUPPRESS_PRE_APPROVAL_AD = 'suppress_pre_approval_ad'
